import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string, bool, number, shape, oneOfType,
} from 'prop-types'

import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'

// Presentational: avatar + author line (username, optional "creator" badge and
// time label) + content. `layout` controls where the content sits relative to
// the avatar: "stacked" (top-level comment - content spans full width below the
// avatar/name row) or "inline" (reply - content beside the avatar), per Figma.
function CommentRow({
  author,
  content,
  creatorLabel = '',
  timeLabel = '',
  className = '',
  layout = 'inline',
}) {
  const avatar = <UserAvatar img={author.avatarUrl} userName={author.username} size="small" />
  const head = (
    <div className="comments-modal__comment-head">
      <span className="comments-modal__comment-author cgt-body-base-semibold">{author.username}</span>
      {author.isAuthor && creatorLabel && (
        <span className="comments-modal__creator-badge cgt-caption">{creatorLabel}</span>
      )}
      {timeLabel && <span className="comments-modal__comment-time cgt-caption">{timeLabel}</span>}
    </div>
  )
  const body = <p className="comments-modal__comment-content cgt-body-base">{content}</p>

  if (layout === 'stacked') {
    return (
      <div className={classnames('comments-modal__comment', 'comments-modal__comment--stacked', className)}>
        <div className="comments-modal__comment-heading">
          {avatar}
          {head}
        </div>
        {body}
      </div>
    )
  }

  return (
    <div className={classnames('comments-modal__comment', className)}>
      {avatar}
      <div className="comments-modal__comment-body">
        {head}
        {body}
      </div>
    </div>
  )
}

CommentRow.propTypes = {
  author: shape({
    id: oneOfType([number, string]),
    username: string,
    avatarUrl: string,
    isAuthor: bool,
  }).isRequired,
  content: string.isRequired,
  creatorLabel: string,
  timeLabel: string,
  className: string,
  layout: string,
}

export default CommentRow
